(function() {
'use strict';

const TR = angular.module('TR');
const lettersOnly = /^[À-ÿa-zA-Z_\-'. ]*$/;
const alphaNumericTenDigits = /^[A-Za-z0-9]{10}$/;
const numericFiveDigits = /^[0-9]{5}$/;
const numericNineDigits = /^[0-9]{9}$/;
const notEnglishLetter = /[À-ÿĀ-ſƀ-ɏɐ-ʯΑ-ϿЀ-ӿԀ-ԯԱ-ևא-ת؀-ۿႠ-ჿ]/;
const multiLangLetters = /^[A-Za-zẞßÀ-ÿĀ-ſƀ-ɏɐ-ʯΑ-ϿЀ-ӿԀ-ԯԱ-ևא-ת؀-ۿႠ-ჿ-.,' ]*$/;
const numbersOnly = /^(\d+\.?\d{0,2}|\.\d{1,2})$/;
const numbersSymbols = /[0-9!#$%&@*+/=?^_`{|}~\\[\]]/;
const phoneNum = /^[()0-9 -]+$/;
const flightNumber = /^(([A-Za-z]{2,3})|([A-Za-z]\d)|(\d[A-Za-z]))(\d{1,})([A-Za-z]?)$/;
const email = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;
const postcodes = {
    Default: /^[A-Za-z\d\s]{1,}$/,
    GB: /^[A-Za-z\d\s]{5,8}$/,
    IE: /^[A-Za-z\d\s]{2,}$/
};
const requiredLengthRangeRegExp = /^\[?(\d+)(?:,(\d+))?]?$/;
function nullOrEmpty(val) {
    return val == null || val.length === 0;
}

function validator(name, watches, failTest, deep, isPureValidator, isObserved) {
    return function(...args) {
        return {
            require: 'ngModel',
            link(scope, el, attr, c) {
                if (!c) { return; }
                if (isPureValidator || attr.pureValidator !== undefined) {
                    c.$validators[name] = () => {
                        return !failTest(scope, el, attr, c, c.$viewValue, args);
                    };
                } else {
                    angular.forEach(watches, function(watch) {
                        scope.$watch(attr[watch], function() {
                            c.$setValidity(name, !failTest(scope, el, attr, c, c.$viewValue, args));
                        }, deep);
                    });
                }
                if (isObserved) {
                    attr.$observe(name, function() {
                        c.$setValidity(name, !failTest(scope, el, attr, c, c.$viewValue, args));
                    });
                }
            }
        };
    };
}

function objectValidator(name, failTest) {
    return function() {
        return {
            require: 'ngModel',
            link(scope, el, attr, c) {
                function validate(value) {
                    return !failTest(scope, el, attr, c, value);
                }

                //For DOM -> model validation
                c.$parsers.unshift(function(value) {
                    const valid = validate(value);
                    c.$setValidity(name, valid);
                    return valid ? value : undefined;
                });

                //For model -> DOM validation
                c.$formatters.unshift(function(value) {
                    c.$setValidity(name, validate(value));
                    return value;
                });
            }
        };
    };
}

TR.directive('emailAddress', [validator('emailAddress', ['ngModel'], function(scope, el, attr, c, value) {
    return !c.$isEmpty(value) && !email.test(value);
})]);

TR.directive('requiredGuest', [objectValidator('requiredGuest', function(scope, el, attr, c, value) {
    return attr.requiredGuest && scope.$eval(attr.requiredGuest) && (nullOrEmpty(value) || nullOrEmpty(value.Title) || nullOrEmpty(value.FirstName) || nullOrEmpty(value.LastName));
})]);

TR.directive('lettersOnly', [validator('lettersOnly', ['ngModel'], function(scope, el, attr, c, value) {
    return !c.$isEmpty(value) && !lettersOnly.test(value);
})]);

TR.directive('requiredDate', ['dateUtil', validator('requiredDate', ['ngModel'], function(scope, el, attr, c, value, dependencies) {
    return !dependencies[0].isValid(value);
})]);

TR.directive('oneMainDriver', [validator('oneMainDriver', ['ngModel'], function(scope, el, attr, c, value) {
    if (attr.oneMainDriver && !scope.$eval(attr.oneMainDriver)) {
        return false;
    }

    if (value) {
        let mainDrivers = 0;
        angular.forEach(value, function(room) {
            angular.forEach(room.Guests, function(guest) {
                if (guest.DriverType === 1) {
                    mainDrivers += 1;
                }
            });
        });
        return mainDrivers !== 1;
    }
    return true;
}, true)]);

TR.directive('numberOfAdditionalDrivers', [validator('numberOfAdditionalDrivers', ['ngModel'], function(scope, el, attr, c, value) {
    if (attr.numberOfAdditionalDrivers && !scope.$eval(attr.numberOfAdditionalDrivers)) {
        return false;
    }

    if (value) {
        let additionalDrivers = 0;
        angular.forEach(value, function(room) {
            angular.forEach(room.Guests, function(guest) {
                if (guest.DriverType === 2) {
                    additionalDrivers++;
                }
            });
        });
        return additionalDrivers !== value.additionalDrivers;
    }
    return true;
}, true)]);
TR.directive('dobCheck', ['dateUtil', validator('dobcheck', ['ngModel'], function(scope, el, attr, c, value) {
    if (value == null) { return false; }
    value = value.slice(0, 10);
    let today = new Date().getTime();
    let checkFutureDate = value.split('-');
    checkFutureDate = new Date(checkFutureDate[0], checkFutureDate[1] - 1, checkFutureDate[2]).getTime();
    return (today - checkFutureDate) < 0;
})]);
TR.directive('ageCheck', ['dateUtil', validator('ageCheck', ['ngModel'], function(scope, el, attr, c, value, dependencies) {
    if (value == null) { return false; }
    if (scope.$eval(attr.validateAge) || scope.guest.Type !== 1) {
        return dependencies[0].getAge(value, dependencies[0].zeroTime(new Date(`${scope.$eval(attr.ageCheck)}Z`))) !== scope.guest.Age;
    }
    return false;
})]);

TR.directive('expiryCheck', [validator('expiryCheck', ['ngModel'], function(scope, el, attr, c, value) {
    const today = new Date();
    if (value.year && value.month) {
        if (value.year > today.getFullYear()) {
            return false;
        } else if (value.year === today.getFullYear()) {
            return value.month < (today.getMonth() + 1);
        }
    }
    return true;
})]);

TR.directive('notDefaultMonthYearIf', [validator('notDefaultMonthYearIf', ['notDefaultMonthYearIf', 'ngModel'], function(scope, el, attr, c, value) {
    if (scope.$eval(attr.notDefaultMonthYearIf)) {
        return !value.year && !value.year > 0 && !value.month && !value.month > 0;
    }
    return false;
})]);

TR.directive('notDefault', [validator('notDefault', ['ngModel'], function(scope, el, attr, c) {
    return !c.$modelValue || parseInt(c.$modelValue) === 0;
})]);

TR.directive('mustCheck', [validator('mustCheck', ['ngModel'], function(scope, el, attr, c) {
    return !c.$modelValue;
})]);

TR.directive('notDefaultIf', [validator('notDefaultIf', ['notDefaultIf', 'ngModel'], function(scope, el, attr, c) {
    return attr.notDefaultIf && scope.$eval(attr.notDefaultIf) && (c.$modelValue == null || c.$modelValue === 0);
})]);

TR.directive('numbersOnly', [function() {
    return (validator('numbersOnly', ['ngModel'], function(scope, el, attr, c) {
        return !c.$isEmpty(c.$modelValue) && !numbersOnly.test(c.$modelValue);
    })());
}]);

TR.directive('alphaNumericTenDigits', [function() {
    return (validator('alphaNumericTenDigits', ['ngModel'], function(scope, el, attr, c) {
        return !c.$isEmpty(c.$modelValue) && !alphaNumericTenDigits.test(c.$modelValue);
    })());
}]);

TR.directive('numericFiveDigits', [function() {
    return (validator('numericFiveDigits', ['ngModel'], function(scope, el, attr, c) {
        return !c.$isEmpty(c.$modelValue) && !numericFiveDigits.test(c.$modelValue);
    })());
}]);

TR.directive('numericNineDigits', [function() {
    return (validator('numericNineDigits', ['ngModel'], function(scope, el, attr, c) {
        return !c.$isEmpty(c.$modelValue) && !numericNineDigits.test(c.$modelValue);
    })());
}]);

TR.directive('phoneNum', [validator('phoneNum', ['ngModel'], function(scope, el, attr, c, value) {
    return !c.$isEmpty(value) && !phoneNum.test(value);
})]);

TR.directive('postcodeIf', [validator('postcodeIf', ['postcodeIf', 'ngModel'], function(scope, el, attr, c, value) {
    if (scope.$eval(attr.postcodeIf)) {
        let exp = _.get(postcodes, scope.$eval(attr.postcodeCountry), postcodes.Default);
        return !exp.test(value);
    }
    return false;
})]);

TR.directive('flightNumber', [validator('flightNumber', ['ngModel'], function(scope, el, attr, c, value) {
    return !c.$isEmpty(value) && !flightNumber.test(value);
})]);

TR.directive('requiredIf', [validator('requiredIf', ['requiredIf', 'ngModel'], function(scope, el, attr, c, value) {
    return attr.requiredIf && scope.$eval(attr.requiredIf) && c.$isEmpty(value);
})]);

TR.directive('mustPassCreditCheck', [validator('mustPassCreditCheck', ['mustPassCreditCheck', 'ngModel'], function(scope, el, attr) {
    return scope.$eval(attr.mustPassCreditCheck) !== 'green';
})]);

TR.directive('sameAs', [validator('sameAs', ['sameAs', 'ngModel'], function(scope, el, attr, c, value) {
    return attr.sameAs && scope.$eval(attr.sameAs) !== value;
})]);

TR.directive('minValue', [validator('minValue', ['minValue', 'ngModel'], function(scope, el, attr, c) {
    return !!attr.minValue && (Number(attr.minValue).toFixed(2)) > Number(c.$modelValue);
})]);

TR.directive('maxValue', [validator('maxValue', ['maxValue', 'ngModel'], function(scope, el, attr, c) {
    return !!attr.maxValue && (Number(attr.maxValue)).toFixed(2) < Number(c.$modelValue);
}, false, false, true)]);

//required-length=[minValue, maxValue] or required-length=exactValue
//required-length=[3 ,5] means 3<=length<=5
//required-length=5 means length = 5
TR.directive('requiredLength', [validator('requiredLength', ['ngModel'], function(scope, el, { requiredLength }, c, value) {
    if (c.$isEmpty(value)) {
        value = '';
    }

    if (c.$isEmpty(requiredLength)) {
        throw new Error('For "required-length" directive it is not specifed value for length. Must be either "=[minValue, maxValue]" or ="exactValue"');
    }
    requiredLength = requiredLength.toString().replace(/\s/g, '');
    const rangeArray = (new RegExp(requiredLengthRangeRegExp)).exec(requiredLength);

    //if no any correctly parsed values - validation failing function returns always false, meaning no impact just as validation is absent
    if (!rangeArray || rangeArray.length < 3) {
        return false;
    }
    //for exact value, we have only one parsed value, which is minValue and maxValue at once;
    if (rangeArray[2] === undefined) {
        rangeArray[2] = rangeArray[1];
    }
    const [, minValue, maxValue] = rangeArray;
    return value.length < minValue || value.length > maxValue;
}, false, true)]);

TR.directive('nameValidation', [validator('nameValidation', ['ngModel'], function(scope, el, attr, c, value) {
    if (c.$isEmpty(value)) {
        return true;
    }
    const regExpPattern = new RegExp(/^[a-zA-Z ',.-]{2,255}$/);
    return !regExpPattern.test(value);
}, false, true)]);

/*
TR.directive('customFailIf', [validator('customFailIf', ['customFailIf', 'ngModel'], function(scope, el, attr, c, value) {
    let r = attr.customFailIf && scope.$eval(attr.customFailIf);
    console.log('customFailIf', attr.customFailIf, scope.$eval(attr.customFailIf), r);
    return r;
})]);
*/

TR.directive('containsEnglishLetters', [validator('containsEnglishLetters', ['ngModel'], (scope, el, attr, c, value) => {
    if (c.$isEmpty(value)) {
        return false;
    }
    const r = new RegExp(notEnglishLetter);
    return r.test(value);
}, false, true)]);

TR.directive('containsNumbersSymbols', [validator('containsNumbersSymbols', ['ngModel'], (scope, el, attr, c, value) => {
    if (c.$isEmpty(value)) {
        return false;
    }
    const r = new RegExp(numbersSymbols);
    return r.test(value);
}, false, true)]);

TR.directive('onlyMultilangLetters', [validator('onlyMultilangLetters', ['ngModel'], (scope, el, attr, c, value) => {
    if (c.$isEmpty(value)) {
        return false;
    }
    const r = new RegExp(multiLangLetters);
    return !r.test(value);
}, false, true)]);

TR.directive('currencyInput', ['numberFilter', '$locale', function(numberFilter, $locale) {
    return {
        restrict: 'A',
        require: 'ngModel',
        priority: 1,
        link(scope, el, attra, c) {
            c.$parsers.unshift(parseCurrency);

            c.$formatters.unshift(formatCurrency);

            el.blur(function() {
                const v = formatCurrency(parseCurrency(c.$viewValue));
                c.$setViewValue(v);
                el.val(v);
            });

            el.keypress(function(e) {
                const code = e.keyCode || e.which;

                if ($.inArray(code, [9, 13, 27]) !== -1) {
                    el.blur();
                    return;
                }
                if (code >= 48 && code <= 57 ||
                    code === $locale.NUMBER_FORMATS.GROUP_SEP.charCodeAt(0) ||
                    $locale.NUMBER_FORMATS.DECIMAL_SEP.charCodeAt(0) === code && e.key !== 'Del' && c.$viewValue.indexOf($locale.NUMBER_FORMATS.DECIMAL_SEP) === -1 ||

                    //backspace & delete
                    code === 8 || code === 46 && e.key === 'Del' ||

                    //Ctrl+A
                    code === 65 && e.ctrlKey === true ||

                    // home, end, left, right
                    code >= 35 && code <= 39) {
                    return;
                }
                e.preventDefault();
            });

            scope.$on('$destroy', function() {
                el.off('keydown');
                el.off('blur');
            });

            function parseCurrency(value) {
                if (!value) { return ''; }
                const index = value.lastIndexOf($locale.NUMBER_FORMATS.DECIMAL_SEP);
                if (index !== -1) {
                    const first = value.substr(0, index);
                    const second = value.substr(index + 1);
                    return parseFloat(`${first.replace(/\D/g, '')}.${second.replace(/\D/g, '')}`).toFixed(2);
                }
                return parseFloat(value.replace(/\D/g, '')).toFixed(2);
            }

            function formatCurrency(value) {
                if (value) {
                    return numberFilter(parseFloat(value), 2);
                }
            }
        }
    };
}]);

    // Allow only 9 numeric characters as input for Skywards ID and restrict other characters
    TR.directive('skywardsId', function() {
        return {
            restrict: 'A',
            require: '?ngModel',
            link(scope, element, attrs, ngModel) {
                if (!ngModel) {
                    return;
                }
                ngModel.$parsers.unshift(function(inputValue) {
                    let digits = inputValue.split('').filter(function(s) { return (!isNaN(s) && s !== ' '); }).join('');
                    if (digits.length > TRPCONFIG.Domain2.SkywardsMembershipNumberCharacterLimit) {
                        digits = digits.substr(0, TRPCONFIG.Domain2.SkywardsMembershipNumberCharacterLimit);
                    }
                    ngModel.$viewValue = digits;
                    ngModel.$render();
                    return digits;
                });
            }
        };
    });
    TR.directive('skywardsNumericNineDigits', ['$http', function($http) {
        return (validator('skywardsNumericNineDigits', ['ngModel'], (scope, el, attr, c) => {
            const rawSkywardsValue = scope.$eval(attr.skywardsNumericNineDigits);
            const invalidDigits = !c.$isEmpty(rawSkywardsValue) && (rawSkywardsValue.length < 9 || rawSkywardsValue.length > TRPCONFIG.Domain2.SkywardsMembershipNumberCharacterLimit);
            if (invalidDigits) {
                return true;
            } else if (!c.$isEmpty(rawSkywardsValue)) {
                const skywardsUrl = '/api/skywards/Validation/';
                return $http.get(`${skywardsUrl}${rawSkywardsValue}`).then(res => {
                    if (res.data) {
                        c.$setValidity('skywardsNumericNineDigits', true);
                    }
                    return !res.data;
                });
            }
            if (c.$isEmpty(rawSkywardsValue)) {
                return false;
            }
            return true;
        })());
    }]);
})();
